export default __webpack_public_path__ + "static/media/part_3_con_03.40bea0c4.gif";